<template>
  <v-container fluid>
    <v-layout style="margin-left: 16px;" align-baseline wrap justify-start>
      <v-flex style="max-width: 637px" xs10 md7>
        <v-text-field
          name="input-1"
          :label="$t('tracking')"
          id="search"
          :title="$t('enterToSearch')"
          :value="barcode"
          @input="v => (barcode = formateValue(v))"
          @keyup.enter="searchTrackingOTP"
          autofocus
        ></v-text-field>
      </v-flex>
      <v-flex style="margin-left: 2px;">
        <v-btn small color="primary" @click="searchTrackingOTP">{{
          $t('search')
        }}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-start v-if="!isWarehouse">
      <v-card>
        <v-card-text>{{ $t('addOTP') }}</v-card-text>
        <v-card-text style="margin-top: -40px">
          <v-layout align-baseline>
            <v-flex md2 mr-3>
              <v-text-field
                ref="tracking"
                :label="$t('tracking')"
                v-model="otpInEdit.tracking"
                :rules="[fieldIsRequired('tracking')]"
                @input="v => (otpInEdit.tracking = formateValue(v))"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3 mr-3>
              <v-text-field
                ref="otp"
                :label="$t('trackingOTPdesc')"
                v-model="otpInEdit.otp"
                @input="v => (otpInEdit.otp = formateValue(v))"
                :rules="[fieldIsRequired('OTP')]"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2 mr-3>
              <v-autocomplete
                :label="$t('warehouse')"
                v-model="otpInEdit.warehouseKey"
                item-text="warehouseName"
                item-value="warehouseId"
                :items="warehouseSite"
              ></v-autocomplete>
            </v-flex>
            <v-flex md2 mr-3>
              <DatePicker
                v-model="otpInEdit.estimateDeliverDate"
                label="estimateDeliverDate"
                :isShowIcon="false"
              ></DatePicker>
            </v-flex>
            <v-flex>
              <v-btn
                small
                color="primary"
                @click="onSubmit"
                :loading="isLoading"
                >{{ $t('submit') }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-layout>
    <v-layout style="margin:20px 0;">
      <v-btn color="primary" @click.stop="downloadTemplate">
        <v-icon dark>cloud_download</v-icon>
        {{ $t('downloadTemplate') }}
      </v-btn>
      <v-btn color="primary" title="importFile" :loading="isUploading">
        <v-icon dark left>cloud_upload</v-icon>
        {{ $t('batchUpload') }}
        <input
          v-on:click="clearSelectionCache"
          type="file"
          class="hideInput"
          @change="uploadOtpFile"
          accept=".csv,.xls,.xlsx"
        />
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="trackingOTPList"
          :pagination.sync="pagination"
          :rows-per-page-items="rowPerPage"
          class="elevation-1"
          :loading="loading"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
          ></v-progress-linear>
          <template v-slot:items="props">
            <td class="text-xs-left">
              {{ props.item.tracking }}
            </td>
            <td class="text-xs-left"><span :style="{backgroundColor: props.item.isAbnormal ? 'yellow' : ''}">{{ props.item.otp }}</span></td>
            <td class="text-xs-left">
              {{ toDateYYYYMMDD(props.item.estimateDeliverDate) }}
            </td>
            <td class="text-xs-left">
              <v-tooltip left v-if="isWarehouse || props.item.isAbnormal">
                <template v-slot:activator="tooltip">
                  <div v-on="tooltip.on">
                    <v-btn
                      icon
                      color="primary"
                      flat
                      @click="
                      handleAbnormalOtp(props.item)
                      "
                    >
                      <v-icon>warning</v-icon>
                    </v-btn>
                    <span v-if="props.item.note && props.item.isAbnormal"> {{ $t('note') + ': ' + props.item.note }}</span>
                  </div>
                </template>
                {{ isWarehouse ? $t('reportAbnormalOtp')  : $t('editAbnormalOtp')  }}
              </v-tooltip>
              <span v-else>
                {{ $t('normal') }}
              </span>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <FormSubmitPopup
      v-model="isShowAbnormalOtpPopup"
      @popupClose="isShowAbnormalOtpPopup = false"
      :title="$t('abnormalOtp')"
      :rightButtonText="$t('send')"
      :rightMethod="sendAbnormalOtpMail"
    >
      <template v-slot:input>
        <v-layout justify-start mb-2>
          <span>
              {{ $t('abnormalOtpNote') }}
          </span>
        </v-layout>
        <v-textarea
          :label="$t('emailTemplate')"
          v-model="abnormalOtpNote"
          :disabled="true"
          outline
        ></v-textarea>
        <v-text-field v-model="abnormalOtp.note"
          style="margin-top: -10px"
          :label="$t('note')"
        ></v-text-field>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import PaginationController from './PaginationController'
import { mapGetters } from 'vuex'
import {
  normalizeInputString,
  readXlsxSheetData,
  checkRules,
  timeTools,
  mediaTools,
  convertTimestampToDateInObj,
  cloneDeep
} from '@/utils/tools'
import FormSubmitPopup from './FormSubmitPopup.vue'
import DatePicker from './DatePicker.vue'

export default {
  components: { PaginationController, FormSubmitPopup, DatePicker },
  mixins: [checkRules, timeTools, mediaTools],
  data () {
    return {
      barcode: '',
      pagination: {},
      rowPerPage: [15, 30, 50, { text: this.$t('all'), value: -1 }],
      headers: [
        {
          text: this.$t('trackingNumber'),
          sortable: false,
          value: 'tracking'
        },
        { text: this.$t('trackingOTP'), sortable: false, value: 'otp' },
        {
          text: this.$t('estimateDeliverDate'),
          sortable: false,
          value: 'estimateDeliverDate'
        },
        {
          text: this.$t('status'),
          value: 'status'
        }
      ],
      otpInEdit: {
        warehouseKey: '',
        estimateDeliverDate: new Date()
      },
      trackingOTPList: [],
      isUploading: false,
      isLoading: false,
      isShowAbnormalOtpPopup: false,
      abnormalOtp: {}
    }
  },
  async mounted () {
    if (!this.isWarehouse && !this.isOrganization) {
      await this.setWarehouseForUser()
    }
  },
  computed: {
    ...mapGetters(['loading', 'uid', 'tenantWorkFor']),
    isWarehouse () {
      return this.$store.getters.activeWarehouse
    },
    isOrganization () {
      return this.$store.getters.activeOrganization
    },
    warehouseSite () {
      return this.isOrganization ? this.$store.getters.warehouses : this.warehousesForUser
    },
    warehousesForUser () {
      let warehouseList = this.$store.getters.warehousesForUser.slice()
      let selfIndex = warehouseList.findIndex(
        item => item.warehouseName === 'self'
      )
      if (selfIndex === -1) {
        return warehouseList
      }
      let [selfItem] = warehouseList.splice(selfIndex, 1)
      warehouseList.push(selfItem)
      return warehouseList
    },
    abnormalOtpNote () {
      return `Tracking: ${this.abnormalOtp?.tracking} (OTP: ${this.abnormalOtp.otp}) is Error \n\n Please recheck and edit the OTP \n\n If in doubt, please contact the warehouse admin`
    }
  },
  methods: {
    searchTrackingOTP () {
      this.$store.dispatch('setLoading', true)
      this.trackingOTPList = []
      if (!this.barcode || this.barcode === '*') {
        this.$store.dispatch('setLoading', false)
        return
      }
      let predicates = [
        {
          field: 'tracking',
          compare: '==',
          value: this.barcode
        }
      ]
      return this.$store
        .dispatch('getTrackingOTP', {
          predicates
        })
        .then(({ docs }) => {
          this.trackingOTPList = docs.map(doc =>
            convertTimestampToDateInObj(doc.data())
          )
          if (this.trackingOTPList.length > 0) {
            this.hintSound()()
          } else {
            this.warningSound()()
          }
        })
        .finally(() => {
          this.$store.dispatch('setLoading', false)
          document.getElementById('search').select()
        })
    },
    onSubmit () {
      this.isLoading = true
      const isValid =
        this.$refs.tracking.validate() && this.$refs.otp.validate()
      if (!isValid) {
        this.isLoading = false
        return
      }
      let payload = {
        ...this.otpInEdit
      }
      if (this.isOrganization) {
        payload.orgKey = this.$store.getters.activeOrganization
      } 
      if (this.$store.getters.uid) {
        payload.uid = this.$store.getters.uid
      }
      return this.$store
        .dispatch('addTrackingOTP', payload)
        .then(async otp => {
          this.isLoading = false
          this.$store.dispatch('showToast', {
            info: this.$t('saveSuccess'),
            level: 'success'
          })
          if (this.otpInEdit.warehouseKey) {
            window.localStorage.setItem(
              this.$store.getters.uid + 'userDefaultWarehouse',
              this.otpInEdit.warehouseKey
            )
          }
          this.otpInEdit.otp = ''
          this.otpInEdit.tracking = ''
          this.$refs.tracking.resetValidation()
          this.$refs.otp.resetValidation()
          if (this.abnormalOtp.tracking) {
            this.barcode = this.abnormalOtp.tracking
            await this.searchTrackingOTP()
          }
        })
        .catch(err => {
          this.isLoading = false
          this.$store.dispatch('showToast', { info: err })
        })
    },
    async uploadOtpFile (e) {
      this.isUploading = true
      try {
        const files = e.target.files
        let rawData = await readXlsxSheetData(files)
        if (rawData.length) this.processSheetData(rawData)
        else this.isUploading = false
      } catch (error) {
        this.isUploading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    async processSheetData (rawData) {
      try {
        rawData.forEach(item => {
          if (!item.otp || !item.tracking) {
            throw Error(this.$t('emptyOtpData'))
          }
          Object.entries(item).forEach(([key, value]) => {
            if (key === 'estimateDeliverDate(YYYY-MM-DD)') {
              const convertedDate = new Date(
                new Date(1900, 0, 1).getTime() +
                  (value - 1) * 24 * 60 * 60 * 1000
              )
              let timestamp = Date.parse(convertedDate)
              if (isNaN(timestamp)) {
                delete item[key]
              }
              item.estimateDeliverDate = convertedDate
            } else {
              item[key] = this.formateValue(value)
            }
          })
        })
        await this.$store
          .dispatch('uploadTrackingOTP', { rawData })
          .then(otp => {
            this.$store.dispatch('showToast', {
              info: this.$t('uploadCompleted'),
              level: 'success'
            })
            this.isUploading = false
          })
      } catch (error) {
        this.isUploading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    formateValue (value) {
      return normalizeInputString(value.toString()).toUpperCase()
    },
    downloadTemplate () {
      this.$store.dispatch('downloadFile', {
        fullPath: 'templates/tracking-OTP-template.xlsx',
        name: 'tracking-OTP-template.xlsx'
      })
    },
    clearSelectionCache (e) {
      e.target.value = null
    },
    async setWarehouseForUser () {
      await this.$store.dispatch('getWarehousesForUser')
      let userDefaultWarehouse = window.localStorage.getItem(
        this.$store.getters.uid + 'userDefaultWarehouse'
      )
      if (
        userDefaultWarehouse &&
        this.warehousesForUser.some(
          item => item.warehouseId === userDefaultWarehouse
        )
      ) {
        this.otpInEdit.warehouseKey = userDefaultWarehouse
      }
      if (this.warehousesForUser.length === 1) {
        this.otpInEdit.warehouseKey = this.warehousesForUser[0].warehouseKey
      }
    },
    handleAbnormalOtp (item) {
      this.abnormalOtp = cloneDeep(item)
      if (this.isWarehouse) {
        this.isShowAbnormalOtpPopup = true
        this.abnormalOtp.isAbnormal = true
      } else {
        this.otpInEdit = cloneDeep(item)
        this.otpInEdit.isAbnormal = false
        this.otpInEdit.otp = ''
      }
    },
    async sendAbnormalOtpMail () {
      await this.$store.dispatch('forwardAbnormalOtp', {abnormalOtp: this.abnormalOtp, content: this.abnormalOtpNote}).then(res => {
        this.$store.dispatch('showToast', {
          info: this.$t('sendSuccess'),
          level: 'success'
        })
        this.barcode = this.abnormalOtp.tracking
        this.searchTrackingOTP()
      }).catch(err => {
        this.isLoading = false
        this.$store.dispatch('showToast', { info: err })
      })
    }
  }
}
</script>

<style>
.hideInput {
  position: absolute;
  top: 0;
  left: -15px;
  width: 100px;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/TrackingOTP.vue